import { Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { useCallback, useMemo } from 'react';
import { useGlobalCore } from '../../../../core/modules/global';
import { CREATE_BUSINESS_DIALOG } from '../../../../core/constants/dialog';
import { useMeCore } from '../../../../core/modules/me';
import { useBusinessCore } from '../../../../core/modules/business';
import { useCompanyCore } from '../../../../core/modules/company';

const Header = () => {
  const { user } = useMeCore();
  const { total } = useBusinessCore();
  const { openDialog } = useGlobalCore();
  const { companyId } = useCompanyCore();

  const canWrite = useMemo(() => user && (user.privileges.superAdmin || user.privileges.writeBusiness), [user]);
  
  const openCreateDialog = useCallback(() => {
    openDialog(CREATE_BUSINESS_DIALOG);
  }, [openDialog]);

  return (
    <div className="p-24 sm:p-32 w-full border-b-1 bg-white header-components">
      <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
        <div className="flex flex-col items-center sm:items-start">
          <Typography className="text-24 md:text-32 font-extrabold tracking-tight leading-none">
            Empresas
          </Typography>
          <Typography className="text-14 font-medium" color="text.secondary">
            {total} empresa/s
          </Typography>
        </div>
        {canWrite && (
          <Button
            variant="contained"
            color="secondary"
            disabled={!companyId}
            onClick={openCreateDialog}
          >
            <AddCircleOutlineOutlinedIcon />
            <span className="mx-8">Crear</span>
          </Button>
        )}
      </div>
    </div>
  );
};

export default Header;
